<template>
  <div style="text-align: center;">
    Vous êtes maintenant déconnecté
    <br>
    Vous allez être redirigé sur la page de connexion dans 2 secondes
  </div>
</template>
<script>
import store from '../../store'

export default {
  name: 'Logout',

  mounted () {
    store.dispatch('LogOut').then(() => {
      // this.setProtectedTimeout(() => { this.goTo('login') }, 2000)
    })
  },
  methods: {

  },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/logout/Logout.vue